import React from 'react';
import { connect } from 'react-redux';
import PasoUnoCodigo from './pasoUnoCodigo.cmpt';
import PasoDosCodigo from './pasoDosCodigo.cmpt';
import PasoDosEliminarCuenta from './pasoDosEliminarCuenta.cmpt';


const mapState = (state) => {
    return {
    	paso: state.miPerfil.pasoCodigo
    };
}

const mapDispatch = (dispatch) => {
    return {
        siguiente: () => {
            dispatch({"type":"MI_PERFIL_PASO_SIGUIENTE_CODIGO"});
        },
        reset: () => {
            dispatch({"type":"MI_PERFIL_RESET_SIGUIENTE_CODIGO"});
        }
    }
}


class ModalCambiarContrasena extends React.Component {
	state = {

	}
	
	componentWillMount = () => {
	    if(this.props.pol){
	        this.props.reset();
	        this.props.siguiente();
	    }
    }
	
	render() {
		return <div>
            { this.props.paso == 0 && 
                <PasoDosEliminarCuenta dp={true}/>
            }
            { this.props.paso == 1 && 
                <PasoUnoCodigo pol={this.props.pol}/>
            }
            { this.props.paso == 2 && 
                <PasoDosCodigo />
            }
        </div>
	}
}

export default connect(mapState, mapDispatch)(ModalCambiarContrasena);


// WEBPACK FOOTER //
// ./src/miPerfil/modalCodigoVerificacion.cmpt.js